import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { AuthShell, field } from '../ui'
import { attorneyAuth } from '../api'

export function Login() {
  const nav = useNavigate()
  const [form, setForm] = useState({ email: '', password: '' })
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value })

  const submit = async (e) => {
    e.preventDefault()
    setError('')
    setBusy(true)
    try {
      await attorneyAuth.login(form.email, form.password)
      nav('/portal')
    } catch (err) {
      setError(err.message || 'Incorrect email or password')
      setBusy(false)
    }
  }

  return (
    <AuthShell
      title="Welcome back"
      subtitle="Sign in to manage your profile and referrals."
      footer={<>New here? <Link to="/signup" className="font-semibold text-emerald-700 hover:underline">Create an account</Link></>}
    >
      <form className="space-y-4" onSubmit={submit}>
        <label className="block text-sm font-medium text-slate-700">Email
          <input type="email" className={field} value={form.email} onChange={set('email')} required /></label>
        <label className="block text-sm font-medium text-slate-700">Password
          <input type="password" className={field} value={form.password} onChange={set('password')} required /></label>
        {error && <p className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">{error}</p>}
        <button type="submit" disabled={busy}
          className="w-full rounded-xl bg-gradient-to-r from-emerald-600 to-teal-600 py-3.5 text-base font-bold text-white shadow-lg transition hover:-translate-y-0.5 hover:from-emerald-700 hover:to-teal-700 disabled:cursor-not-allowed disabled:opacity-60">
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </AuthShell>
  )
}

export default Login
